import { motion } from "framer-motion";
import { ANKH_PATHS, ANKH_JEWEL } from "@/lib/ankh";

const draw = (delay) => ({
  initial: { pathLength: 0, opacity: 0 },
  animate: { pathLength: 1, opacity: 1 },
  transition: { duration: 1.6, delay, ease: [0.65, 0, 0.35, 1] },
});

export const Sigil = ({ className = "", animate = false, stroke = "#D9B47A", width = 3 }) => {
  const p = (d, delay) =>
    animate ? <motion.path d={d} {...draw(delay)} /> : <path d={d} />;
  return (
    <svg viewBox="-50 -50 100 100" className={className} aria-hidden="true">
      <g fill="none" stroke={stroke} strokeWidth={width} strokeLinejoin="round" strokeLinecap="round">
        {ANKH_PATHS.map((d, i) => <g key={d}>{p(d, i * 0.2)}</g>)}
      </g>
      <motion.circle
        cx={ANKH_JEWEL.cx} cy={ANKH_JEWEL.cy} r={ANKH_JEWEL.r} fill="#C2414F"
        initial={animate ? { scale: 0 } : false}
        animate={{ scale: 1 }}
        transition={{ delay: animate ? 1.3 : 0, duration: 0.6 }}
      />
    </svg>
  );
};

const ticks = Array.from({ length: 48 }, (_, i) => i * 7.5);

export const GrandSigil = ({ className = "" }) => (
  <svg viewBox="-110 -110 220 220" className={className} aria-hidden="true" data-testid="hero-sigil">
    <g fill="none" stroke="#D9B47A">
      <g className="spin-slow" strokeOpacity="0.5">
        <circle r="104" strokeWidth="0.4" />
        {ticks.map((a) => (
          <line key={a} x1="0" y1="-104" x2="0" y2={a % 30 === 0 ? -94 : -99} strokeWidth="0.5" transform={`rotate(${a})`} />
        ))}
      </g>
      <g className="spin-rev" strokeOpacity="0.35">
        <circle r="88" strokeWidth="0.4" strokeDasharray="1 3" />
        {Array.from({ length: 16 }, (_, i) => (
          <path key={i} d="M0 -86 Q 9 -74 0 -62 Q -9 -74 0 -86 Z" strokeWidth="0.5" transform={`rotate(${i * 22.5})`} />
        ))}
      </g>
      <circle r="58" strokeWidth="0.5" strokeOpacity="0.4" />
      <g strokeWidth="0.75" strokeOpacity="0.95" strokeLinejoin="round" strokeLinecap="round" transform="scale(1.2)">
        {ANKH_PATHS.map((d) => <path key={d} d={d} />)}
      </g>
    </g>
    <circle r={ANKH_JEWEL.r * 1.2} cy={ANKH_JEWEL.cy * 1.2} fill="#C2414F" />
  </svg>
);
